<template>
  <div class="content">
    <el-tabs class="tabLv3 relaAlarm" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="deviceData" class="dataSend">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i>数据上报
        </span>
        <!-- 数据推送日志 -->
        <div>
          <!-- TODO -->
          <div class="dataLog">
            <p v-for="(log, index) in dataLogs" :key="index">
              <span>{{ formatDate(log.time) }}</span>
              <span>{{ log.content }}</span>
            </p>
          </div>
          <div class="btnLine">
            <button class="w_next_button cancelButton" @click="clearLog">清屏</button>
          </div>
        </div>
        <!-- 数据推送表单 -->
        <div>
          <el-form ref="dataForm" :disabled="!!defaultTimer" class="form" :model="defaultInfo" :rules="defaultInfoRules" label-width="150px">
            <el-row>
              <el-radio v-model="mode" label="data" >数据上报</el-radio>
              <el-radio v-model="mode" label="alarm">告警上报</el-radio>
            </el-row>
            <el-form-item label="应用系统：" prop="systemId">
              <el-select
                :popper-append-to-body="false"
                v-model="defaultInfo.systemId"
                placeholder="请选择应用系统"
                @change="selectSystem"
              >
                <el-option v-for="sys in systemList" :label="sys.name" :key="sys.id" :value="sys.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="设备类型：" prop="deviceType">
              <el-select
                :popper-append-to-body="false"
                v-model="defaultInfo.deviceType"
                placeholder="请选择设备类型"
                @change="selectDeviceType"
              >
                <el-option v-for="type in deviceTypeList" :label="type.typeName" :key="type.id" :value="type.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="选择设备：" prop="deviceName">
              <el-input v-model="defaultInfo.deviceName" placeholder="请选择设备" @focus="initDeviceBox" readonly />
            </el-form-item>
            <el-form-item label="数据流：" prop="dataFlow" v-if="mode === 'data'">
              <el-select
                :popper-append-to-body="false"
                v-model="defaultInfo.dataFlow"
                placeholder="请选择数据流"
                multiple
              >
                <el-option v-for="type in dataFlowList" :label="type.name" :key="type.id" :value="type.id" />
              </el-select>
            </el-form-item>
            <el-row v-if="mode === 'data'">
              <el-radio v-model="dataFlowMode" label="fix">固定值&emsp;</el-radio>
              <el-radio v-model="dataFlowMode" label="random">随机值&emsp;</el-radio>
            </el-row>
            <el-form-item label="固定值：" prop="dataFlowValue" v-if="mode === 'data' && dataFlowMode === 'fix'">
              <el-input v-model="defaultInfo.dataFlowValue" placeholder="请填写数据值" />
            </el-form-item>
            <el-form-item class="random" label="随机值：" v-if="mode === 'data' && dataFlowMode === 'random'">
              <el-col>
                <el-form-item prop="dataFlowMin">
                  <el-input type="number" v-model="defaultInfo.dataFlowMin" placeholder="最小值" />
                </el-form-item>
              </el-col>
              <el-col>-</el-col>
              <el-col>
                <el-form-item prop="dataFlowMax">
                  <el-input type="number" v-model="defaultInfo.dataFlowMax" placeholder="最大值" />
                </el-form-item>
              </el-col>
            </el-form-item>
            <el-form-item label="告警内容：" prop="content" v-if="mode === 'alarm'">
              <el-input type="textarea" v-model="defaultInfo.content" placeholder="请选输入告警内容" />
            </el-form-item>
            <el-form-item label="时间间隔：" prop="interval">
              <el-input type="number" v-model="defaultInfo.interval" placeholder="请输入时间间隔" />&emsp;分钟
            </el-form-item>
            <el-form-item label="次数限制：" prop="limit">
              <el-input type="number" v-model="defaultInfo.limit" placeholder="请输入限制次数" />&emsp;次
            </el-form-item>
          </el-form>
          <p>
            <button class="w_next_button cancelButton" :disabled="!defaultTimer" @click="clearDefaultInterval">结束上报</button>
            <button class="w_next_button cancelButton" :disabled="!!defaultTimer" @click="sendByInterval">{{ defaultTimer ? '上报计数' + timerCount : '定时上报' }}</button>
            <button class="w_next_button confirmButton" :disabled="!!defaultTimer" @click="sendNow">立即上报</button>
          </p>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-dialog
      title="设备列表"
      class="deviceDialog"
      :visible.sync="deviceBoxShow"
      inline
    >
      <div v-if="deviceList.length" class="full">
        <p><span>操作</span><span>设备名称</span><span>设备编码</span><span>设备状态</span></p>
        <p v-for="(dv, index) in deviceList" :key="index">
          <span @click="selectDevice(dv.deviceId)">
            <i :class="['checkbox', selectDeviceId === dv.deviceId ? 'selected' : '']"></i>
          </span>
          <span>{{ dv.deviceName }}</span>
          <span>{{ dv.deviceId }}</span>
          <span>{{ dv.deviceStatusName }}</span>
        </p>
      </div>
      <div v-else class="empty">暂无数据</div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="deviceBoxShow = false">取 消</el-button>
        <el-button size="small" type="primary" @click="confirmSelectDevice">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      tabName: 'deviceData',
      mode: 'alarm',
      dataFlowMode: 'fix',
      // 应用系统列表
      systemList: [],
      // 设备类型全列表
      deviceTypeAllList: [],
      // 当前设备类型列表
      deviceTypeList: [],
      // 数据流全列表
      dataFlowAllList: [],
      // 当前数据流列表
      dataFlowList: [],
      // 可选择设备列表
      deviceList: [],
      // 设备列表展现
      deviceBoxShow: false,
      // 选中设备编码
      selectDeviceId: undefined,
      // 定时器
      defaultTimer: undefined,
      // 定时器执行次数
      timerCount: 0,
      // 验证规则
      defaultInfoRules: {
        deviceName: [
          { required: true, message: '请选择设备' }
        ],
        content: [
          { required: true, message: '请填写告警内容' }
        ],
        dataFlow: [
          { required: true, message: '请选择数据流' }
        ],
        dataFlowValue: [
          { required: true, message: '请填写数据值' }
        ],
        dataFlowMax: [
          { required: true, message: '请填写数据最大值' }
        ],
        dataFlowMin: [
          { required: true, message: '请填写数据最小值' }
        ],
      },
      // 表单信息
      defaultInfo: {
        systemId: undefined,
        deviceType: undefined,
        dataFlow: undefined,
        dataFlowValue: undefined,
        dataFlowMax: undefined,
        dataFlowMin: undefined,
        deviceId: undefined,
        deviceName: undefined,
        content: undefined,
        interval: 5,
        limit: 1
      },
      // 上报日志
      dataLogs: []
    }
  },
  methods: {
    initSystemList() {
      this.$axiosget('manager/operatingSystemApi/getOperatingSystemsByCompanyId', {
          params: {
            compayId: localStorage.getItem("companyId")
          },
      }).then((res) => {
        this.systemList = res.data.data || []
      })
    },
    selectSystem(systemId) {
      this.defaultInfo.deviceType = undefined
      this.defaultInfo.dataFlow = undefined
      this.defaultInfo.deviceId = undefined
      this.defaultInfo.deviceName = undefined
      this.selectDeviceId = undefined
      this.deviceTypeList = []
      this.dataFlowList = []
      this.deviceList = []
      let tempDeviceTypeList = this.deviceTypeAllList.filter(it => it.systemId === systemId)
      if (tempDeviceTypeList.length) {
        this.deviceTypeList = tempDeviceTypeList
      } else {
        this.$axiosget('manager/operatingSystemApi/getDeviceTypeByOperatingId', {
          params: {
            id: systemId
          }
        }).then((res) => {
          let temp = res.data.data || []
          temp.forEach(t => {
            let { id, typeName } = t
            this.deviceTypeList.push({
              id, typeName, systemId
            })
          })
          this.deviceTypeAllList = this.deviceTypeAllList.concat(this.deviceTypeList)
        })
      }
    },
    selectDeviceType(deviceType) {
      this.defaultInfo.dataFlow = undefined
      this.defaultInfo.deviceId = undefined
      this.defaultInfo.deviceName = undefined
      this.selectDeviceId = undefined
      this.dataFlowList = []
      this.deviceList = []
      let tempDataFlowList = this.dataFlowAllList.filter(it => it.deviceType === deviceType)
      if (tempDataFlowList.length) {
        this.dataFlowList = tempDataFlowList
      } else {
        this.$axiosget('manager/dataFlow/queryAll', {
          params: {
            device_type_id: this.defaultInfo.deviceType,
            pageSize: 99
          }
        }).then((res) => {
          let temp = res.data.data.list || []
          temp.forEach(t => {
            let { id, name, data_flag, unit } = t
            this.dataFlowList.push({
              id, name, unit,
              dataFlag: data_flag
            })
          })
          this.dataFlowAllList = this.dataFlowAllList.concat(this.dataFlowList)
        })
      }
    },
    initDeviceBox() {
      this.selectDeviceId = undefined
      this.defaultInfo.deviceId = undefined
      this.defaultInfo.deviceName = undefined
      this.deviceList = []
      if (!this.defaultInfo.systemId || !this.defaultInfo.deviceType) {
        this.$message.warning('请先选择应用系统或设备类型')
        this.deviceBoxShow = false
      } else {
        Promise.resolve().then(() => {
          this.queryDeviceList()
          this.deviceBoxShow = true
        })
      }
    },
    queryDeviceList() {
      this.$axiosget('operation/device/list', {
        params: {
          system_id: this.defaultInfo.systemId,
          deviceType: this.defaultInfo.deviceType,
          pageSize: 999
        }
      }).then((res) => {
        this.deviceList = res.data.data.deviceList || []
      })
    },
    selectDevice(deviceId) {
      this.selectDeviceId = this.selectDeviceId === deviceId ? undefined : deviceId
    },
    confirmSelectDevice() {
      if (!this.selectDeviceId) {
        this.$message.warning('未选择设备！')
      } else {
        this.defaultInfo.deviceName = this.deviceList.find(it => it.deviceId === this.selectDeviceId).deviceName || undefined
        this.defaultInfo.deviceId = this.selectDeviceId
        this.deviceBoxShow = false
      }
    },
    sendByInterval() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          if (this.defaultInfo.limit < 0 || this.defaultInfo.interval < 0) {
            this.$message.warning('请填写正确的时间间隔和次数限制！')
            return
          }
          this.defaultTimer = setInterval(() => {
            if (this.mode === 'data') {
              if (this.dataFlowMode === 'random') {
                if (this.defaultInfo.dataFlowMin * 1 >= this.defaultInfo.dataFlowMax * 1) {
                  this.$message.warning('数据最大值必须大于最小值！')
                  return
                }
              }
              this.sendDeviceData()
            } else {
              this.sendAlarmData()
            }
            this.timerCount++
            if (this.defaultInfo.limit !== 0 && this.timerCount >= this.defaultInfo.limit) {
              this.clearDefaultInterval()
            }
          }, this.defaultInfo.interval * 60000)
        }
      })
    },
    clearDefaultInterval() {
      if (this.defaultTimer) {
        clearInterval(this.defaultTimer)
        this.defaultTimer = undefined
        this.timerCount = 0
      } else {
        this.$message.warning('暂未开启定时上报！')
      }
    },
    sendNow() {
      console.log(this.defaultInfo);
      console.log(this.dataFlowList);
      
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          if (this.mode === 'data') {
            if (this.dataFlowMode === 'random') {
              if (this.defaultInfo.dataFlowMin * 1 >= this.defaultInfo.dataFlowMax * 1) {
                this.$message.warning('数据最大值必须大于最小值！')
                return
              }
            }
            this.sendDeviceData()
          } else {
            this.sendAlarmData()
          }
        }
      })
    },
    sendDeviceData() {
      // 调用上报数据接口
      if (this.dataFlowMode === "random") {
        let min = this.defaultInfo.dataFlowMin * 1
        let max = this.defaultInfo.dataFlowMax * 1
        // random [0, 1)
        let rd = ((Math.random() * (max - min)).toFixed(2) * 1 + min) + ''
        this.defaultInfo.dataFlowValue = (rd.indexOf('.') !== -1 && rd.length - rd.indexOf('.') > 3) ? rd.slice(0, rd.indexOf('.') + 3): rd
      }
      console.log('调用上报数据接口')
      // let df = this.dataFlowList.find(it => it.id === this.defaultInfo.dataFlow)
      // let dataMap = {}
      // let key = df.dataFlag
      // dataMap[key] = this.defaultInfo.dataFlowValue
      const selectedDataFlows = this.defaultInfo.dataFlow.map(value => {
        return this.dataFlowList.find(item => item.id === value);
      }).filter(item => item !== undefined); // 过滤掉未找到的情况
      // 构建 dataMap
      const dataMap = {};
      if (selectedDataFlows.length > 0 && this.defaultInfo.dataFlowValue) {
        // 统一替换中文逗号为英文逗号，并按逗号分割成数组
        const values = this.defaultInfo.dataFlowValue
          .replace(/，/g, ',')  // 替换中文逗号
          .split(',')          // 分割成数组
          .map(v => v.trim()); // 去空格

        if (values.length !== selectedDataFlows.length) {
          this.$message.warning('数据流数量与输入值数量不一致，请检查输入');
          return;
        }

        selectedDataFlows.forEach((flow, index) => {
          const key = flow.dataFlag; // 获取 dataFlag 作为 key
          const value = values[index]; // 获取对应的值
          dataMap[key] = value;
        });
      }

      console.log('生成的 dataMap:', dataMap);
      this.$axiospost('operation/device/handDeviceData', {
        deviceId : this.defaultInfo.deviceId,
        companyId : localStorage.getItem('companyId'),
        dataMap: dataMap
      }).then((res) => {
        console.log("数据上报成功！")
      })// 构造 log 内容
      const logEntries = selectedDataFlows.map(flow => {
        const value = dataMap[flow.dataFlag];
        return `${flow.name}[${flow.dataFlag}]=${value}${flow.unit || ''}`;
      });
      const content = `设备[${this.defaultInfo.deviceName}]上报数据：${logEntries.join('，')}`;
      this.dataLogs.push({
        time: new Date(),
        content
      })
    },
    sendAlarmData() {
      // 调用上报告警接口
      console.log('调用上报告警接口')
      this.$axiospost('operation/device/handTriggerAlarm', {
        deviceId : this.defaultInfo.deviceId,
        alarmDesc : this.defaultInfo.content,
        time : this.formatDate(new Date())
      }).then((res) => {
        console.log("告警上报成功！")
      })
      let content = '设备[' + this.defaultInfo.deviceName + ']上报告警：' + this.defaultInfo.content
      this.dataLogs.push({
        time: new Date(),
        content
      })
    },
    clearLog() {
      this.dataLogs = []
    },
    formatDate(date) {
      return date.getFullYear() + '-' + this.fullLen((date.getMonth() + 1), 2) + '-' + this.fullLen(date.getDate(), 2) + ' '
           + this.fullLen(date.getHours(), 2) + ':' + this.fullLen(date.getMinutes(), 2) + ':' + this.fullLen(date.getSeconds(), 2)
    },
    fullLen(val, len) {
      val += ''
      if (val.length !== len) {
        if (val.length > len) {
          val = val.slice(0, len)
        } else {
          for (let c = 0; c < len - val.length; c++) {
            val = '0' + val
          }
        }
      }
      return val
    }
  },
  mounted() {
    this.initSystemList()
  },
  beforeDestroy() {
    try {
      clearInterval(this.defaultTimer)
      this.defaultTimer = undefined
    } catch (e) {
      // ignored
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  width: 100%;
  height: 100%;
  .dataSend {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-evenly;
    > div {
      width: 50%;
      height: auto;
      min-height: 800px;
      font-size: 14px;
      .form {
        width: 60%;
        margin: 80px auto 0 auto;
        /deep/ .el-select, .el-input, .el-textarea {
          width: 72% !important;
        }
        .random /deep/ .el-col {
         .el-input{
            width: 100% !important;
          }
        }
        .random /deep/ .el-col:nth-child(2n - 1) {
          width: 30% !important;
        }
        .random /deep/ .el-col:nth-child(2n) {
          width: 2% !important;
        }
        .random /deep/ .el-col:first-child {
          margin-right: 5%;
        }
        .random /deep/ .el-col:last-child {
          margin-left: 5%;
        }
        /deep/ .el-row {
          text-align: center;
          margin: 10px 0 20px 0;
        }
      }
      p {
        padding: 10px 0;
        text-align: center;
        button {
          max-width: 140px;
          margin: 0 10px;
          font-size: 12px;
        }
      }
      .dataLog {
        width: 80%;
        margin: 80px auto 0 auto;
        background: #000;
        color: #ccc;
        border: 1px solid #ccc;
        min-height: 50%;
        max-height: 60%;
        overflow-y: scroll;
        p {
          text-align: left;
          padding: 4px 10px;
          line-height: 20px;
        }
      }
      .btnLine {
        text-align: center;
        padding: 10px 0;
        button {
          font-size: 12px;
        }
      }
    }
  }
  button:not(:disabled):hover {
    transform: scale(1.2);
  }
  button:disabled {
    background: #999 !important;
  }
  .deviceDialog {
    /deep/ .el-dialog__body {
      .full {
        max-height: 720px;
        overflow-y: auto;
        p {
          min-height: 36px;
          line-height: 36px;
          display: flex;
          flex-flow: row nowrap;
          border-top: 1px solid rgba(221, 221, 221, 0.2);
          justify-content: space-evenly;
          color: #ccc;
          font-size: 14px;
          border-radius: 2px;
          span {
            min-width: 100px;
            cursor: pointer;
            width: 39%;
            text-align: center;
            .checkbox {
              width: 14px;
              height: 14px;
              display: inline-block;
              margin: 0 auto;
              background: #ccc;
              border-radius: 4px;
            }
            .checkbox.selected {
              background: #00a7ff;
            }
          }
          span:first-child {
            width: 10%;
          }
          span:last-child {
            width: 12%;
          }
        }
        p:nth-child(2n - 1) {
          background: rgba(46, 54, 87, 0.32);
        }
        p:first-child {
          background: rgba(46, 54, 87, 0.92) !important;
        }
        p:hover {
          background: rgba(46, 54, 87, 0.72) !important;
        }
      }
      .empty {
        min-height: 36px;
        line-height: 36px;
        color: #ccc;
        text-align: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute2/systemConfiguration/first/ToolManagement/dataSend/index.vue